// extracted by mini-css-extract-plugin
module.exports = {"container":"bx","price":"cx","salePrice":"dx","msrp":"ex","percentOff":"fx","lowStock":"gx","oos":"hx","verbiage":"ix"};